import { ReactNode } from "react";

import { Badge } from "antd";

import { useSystemStatusSelector } from "hooks/useSystemStatusSelector";

import { StatusWrapper } from "./UserAvatarWithStatus.styles";

interface UserAvatarWithStatusProps {
  children: ReactNode;
}

const UserAvatarWithStatus = ({ children }: UserAvatarWithStatusProps) => {
  const { hasActiveIssue, currentStatus } = useSystemStatusSelector();

  const getStatusColor = () => {
    if (!currentStatus) return undefined;

    switch (currentStatus.type) {
      case "major":
        return "error";
      case "partial":
        return "warning";
      case "planned":
        return "processing";
      default:
        return undefined;
    }
  };

  if (!hasActiveIssue) {
    return <>{children}</>;
  }

  return (
    <StatusWrapper>
      <Badge status={getStatusColor()} dot size="default" offset={[-4, 4]}>
        {children}
      </Badge>
    </StatusWrapper>
  );
};

export default UserAvatarWithStatus;
